import { render } from "./DialogGRColorList.vue?vue&type=template&id=3fbb4478&scoped=true"
import script from "./DialogGRColorList.vue?vue&type=script&lang=js"
export * from "./DialogGRColorList.vue?vue&type=script&lang=js"

import "./DialogGRColorList.vue?vue&type=style&index=0&id=3fbb4478&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbb4478"]])

export default __exports__